import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { HrFlexContainer, HrTitleContainer, HrTitleH4 } from '@components/styles/hr-styles';
import { SectionNetworks } from './networks';
import { DisplaySettingsContext } from '../../store/display-settings';

export const ControllerNetworks = observer(
  ({ vacancyRequirement, postulant, register, formState, control, getValues, setValue, unregister, action }) => {
    const [t] = useTranslation();

    const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

    return (
      <HrFlexContainer flexDirection='column' alignItems='flex-start'>
        {/* REDES */}
        <HrTitleContainer borderBottom={darkMode ? '1px solid #767676' : ''} >
          <HrTitleH4 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''} isRequired={vacancyRequirement.social_networks === 1}>{t('postulant.networks.title')}</HrTitleH4>
        </HrTitleContainer>

        <SectionNetworks
          vacancyRequirement={vacancyRequirement}
          register={register}
          getValues={getValues}
          setValue={setValue}
          unregister={unregister}
          control={control}
          formState={formState}
          action={action}
          postulant={postulant}
        />
      </HrFlexContainer>
    );
  }
);
